export const ColumnTypes = {
	TextLine: 'text-line',
	TextLong: 'text-long',
	TextRich: 'text-rich',
	Selection: 'selection',
	SelectionMulti: 'selection-multi',
	Number: 'number',
	SelectionCheck: 'selection-check',
	TextLink: 'text-link',
	NumberStars: 'number-stars',
	NumberProgress: 'number-progress',
	DatetimeDate: 'datetime-date',
	DatetimeTime: 'datetime-time',
	Datetime: 'datetime',
}
